import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 pt-40 pb-20">
        <span className="text-[11px] tracking-[0.3em] uppercase text-onyx-metal">Services</span>
        <h1 className="font-display font-extrabold text-5xl md:text-8xl tracking-tightest mt-5 leading-[0.9] max-w-4xl">Railing systems, end to end.</h1>
        <p className="text-onyx-metal text-lg mt-8 max-w-2xl leading-relaxed">Confident, technical, and self-performed. Each railing system below is engineered, fabricated, and installed by ONYX crews.</p>
      </section>

      <div>
        {services.map((s, i) => (
          <section key={s.id} data-testid={`service-block-${i}`} className={`border-t border-black/10 ${i % 2 ? "bg-onyx-charcoal text-white" : "bg-onyx-cream"}`}>
            <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-20 md:py-28 grid lg:grid-cols-2 gap-12 items-center">
              <div className={`${i % 2 ? "lg:order-2" : ""}`}>
                <Reveal>
                  <span className={`font-mono text-sm ${i % 2 ? "text-onyx-wood" : "text-onyx-wood"}`}>0{i + 1} — Service</span>
                  <h2 className="font-display font-extrabold text-4xl md:text-5xl tracking-tightest mt-4 leading-none">{s.title}</h2>
                  <p className={`mt-6 text-lg leading-relaxed ${i % 2 ? "text-white/70" : "text-onyx-metal"}`}>{s.description || s.short_description}</p>
                  <Link to="/contact" className={`inline-flex items-center gap-3 mt-8 text-sm tracking-[0.12em] uppercase group ${i % 2 ? "text-onyx-wood" : "text-onyx-black hover:text-onyx-wood"} transition-colors`}>
                    Discuss this scope <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </Link>
                </Reveal>
              </div>
              <Reveal className={`${i % 2 ? "lg:order-1" : ""}`}>
                <motion.div whileHover={{ scale: 1.02 }} transition={{ duration: 0.6 }} className="relative h-[440px] overflow-hidden">
                  <img src={fileUrl(s.image)} alt={s.title} className="w-full h-full object-cover" />
                </motion.div>
              </Reveal>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
